// store/reducer.ts

import {
    InfluencerCampaignActionTypes,
    InfluencerCampaignState,
    SET_ERROR,
    SET_INFLUENCER_CAMPAIGN,
    SET_LOADING,
} from './types';

export const influencerCampaignDefaultState = {
    name: '',
    description: '',
    managerEmails: [],
    startDate: null,
    endDate: null,
    groupIds: [],
    overview: '',
    image: null,
    link: '',
    contentDueDate: null,
    contentApprovalRequired: false,
    campaignTargetBudget: 0,
    discountCode: '',
    campaignHashtags: [],
    defaultHashtags: [],
    defaultMentions: [],
    participants: [],
};

const initialState: InfluencerCampaignState = {
    influencerCampaign: influencerCampaignDefaultState,
    isLoading: false,
    error: '',
};

export function influencerCampaignReducer(
    state = initialState,
    action: InfluencerCampaignActionTypes,
): InfluencerCampaignState {
    switch (action.type) {
        case SET_INFLUENCER_CAMPAIGN:
            return {
                ...state,
                influencerCampaign: action.payload,
            };

        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        default:
            return state;
    }
}
